import { DELETE_TYPED_ASYNC, GET_TYPED_ASYNC, POST_TYPED_ASYNC } from '../helpers/httpHelper';
import { ITrainingJobTitle } from '../common/data/dtos/training-job-title';

const BASE_PATH = 'api/TrainingJobTitle';

interface TrainingJobTitleResponse {
    success: boolean;
    trainingJobTitle?: ITrainingJobTitle;
    trainingJobTitles?: ITrainingJobTitle[];
    error?: string;
}

type CreateTrainingJobTitleType = Omit<ITrainingJobTitle, 'id'> | Partial<ITrainingJobTitle>;

const createTrainingJobTitle = async (trainingJobTitle: CreateTrainingJobTitleType[]): Promise<TrainingJobTitleResponse> => {
    try {
        const response = await POST_TYPED_ASYNC<ITrainingJobTitle>(`${BASE_PATH}`, trainingJobTitle);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const deleteTrainingJobTitle = async (id: string): Promise<TrainingJobTitleResponse> => {
    try {
        const response = await DELETE_TYPED_ASYNC<ITrainingJobTitle>(`${BASE_PATH}/${id}`);

        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getTrainingJobTitleByJobTitle = async (id: string): Promise<TrainingJobTitleResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<ITrainingJobTitle>(`${BASE_PATH}/GetByJobTitle?id=${id}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, trainingJobTitles: response.collection };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

export default {
    createTrainingJobTitle,
    deleteTrainingJobTitle,
    getTrainingJobTitleByJobTitle,
};
